"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetAccountAllOfMarketingAutomation {
    static getAttributeTypeMap() {
        return GetAccountAllOfMarketingAutomation.attributeTypeMap;
    }
}
GetAccountAllOfMarketingAutomation.discriminator = undefined;
GetAccountAllOfMarketingAutomation.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "enabled",
        "baseName": "enabled",
        "type": "boolean"
    }
];
exports.GetAccountAllOfMarketingAutomation = GetAccountAllOfMarketingAutomation;
//# sourceMappingURL=getAccountAllOfMarketingAutomation.js.map